import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	unknownErrorHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unknownErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unknownErrorHeaderIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unknownErrorDescriptionIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unknownErrorDescriptionIssueTermRefreshGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	unknownErrorHeader: {
		id: 'issue-view-errors.unknown-error-view.unknown-error-header',
		defaultMessage: "We couldn't connect to that issue",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	unknownErrorDescription: {
		id: 'issue-view-errors.unknown-error-view.unknown-error-description',
		defaultMessage:
			"Make sure that this issue actually exists in that project. If it does, try again in a few minutes. If you still can't link to the issue, contact your Jira admin.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	unknownErrorHeaderIssueTermRefresh: {
		id: 'issue-view-errors.unknown-error-view.unknown-error-header-issue-term-refresh',
		defaultMessage: "We couldn't connect to that work item.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	unknownErrorDescriptionIssueTermRefresh: {
		id: 'issue-view-errors.unknown-error-view.unknown-error-description-issue-term-refresh',
		defaultMessage:
			"Make sure that this work item actually exists in that project. If it does, try again in a few minutes. If you still can't link to the work item, contact your Jira admin.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	unknownErrorDescriptionIssueTermRefreshGalaxia: {
		id: 'issue-view-errors.unknown-error-view.unknown-error-description-issue-term-refresh-galaxia',
		defaultMessage:
			"Make sure that this work item actually exists in that space. If it does, try again in a few minutes. If you still can't link to the work item, contact your Jira admin.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});
